module.exports = __webpack_public_path__ + "img/generating.bba084c0.svg";